import { useState } from "react";
import Image from "./components/Image";
import bg1 from "./assets/bg_1.jpg";
import bg2 from "./assets/bg_2.jpg";
import bg3 from "./assets/bg_3.jpg";
import bg4 from "./assets/bg_4.jpg";
import bg5 from "./assets/bg_5.jpg";
import bg6 from "./assets/bg_6.jpg";
import bg7 from "./assets/bg_7.jpg";
import bg8 from "./assets/bg_8.jpg";
import bg9 from "./assets/bg_9.jpg";
import bg10 from "./assets/bg_10.jpg";
import zero from "./assets/0.png";
import one from "./assets/1.png";
import two from "./assets/2.png";
import three from "./assets/3.png";
import four from "./assets/4.png";
import five from "./assets/5.png";
import six from "./assets/6.png";
import seven from "./assets/7.png";
import eight from "./assets/8.png";
import nine from "./assets/9.png";
import a from "./assets/A.png";
import b from "./assets/B.png";
import c from "./assets/C.png";
import d from "./assets/D.png";
import e from "./assets/E.png";
import f from "./assets/F.png";
import g from "./assets/G.png";
import h from "./assets/H.png";
import i from "./assets/I.png";
import j from "./assets/J.png";
import k from "./assets/K.png";
import l from "./assets/L.png";
import m from "./assets/M.png";
import n from "./assets/N.png";
import o from "./assets/O.png";
import p from "./assets/P.png";
import q from "./assets/Q.png";
import r from "./assets/R.png";
import s from "./assets/S.png";
import t from "./assets/T.png";
import u from "./assets/U.png";
import v from "./assets/V.png";
import w from "./assets/W.png";
import x from "./assets/X.png";
import y from "./assets/Y.png";
import z from "./assets/Z.png";
import and from "./assets/and.png";

function App() {
	const [bgImage, setBgImage] = useState("bg1");
	const [inputText, setInputText] = useState("Welcome");

	const handleKeyPress = (e) => {
		setInputText(e.target.value);
		console.log(e.target.value);
	};

	return (
		<div className="container__img-box">
			<div className="img-box">
				{bgImage === "bg1" && <img className="img" src={bg1} alt="" />}
				{bgImage === "bg2" && <img className="img" src={bg2} alt="" />}
				{bgImage === "bg3" && <img className="img" src={bg3} alt="" />}
				{bgImage === "bg4" && <img className="img" src={bg4} alt="" />}
				{bgImage === "bg5" && <img className="img" src={bg5} alt="" />}
				{bgImage === "bg6" && <img className="img" src={bg6} alt="" />}
				{bgImage === "bg7" && <img className="img" src={bg7} alt="" />}
				{bgImage === "bg8" && <img className="img" src={bg8} alt="" />}
				{bgImage === "bg9" && <img className="img" src={bg9} alt="" />}
				{bgImage === "bg10" && (
					<img className="img" src={bg10} alt="" />
				)}
			</div>

			<div className="text-image">
				{[...inputText.toLowerCase()].map((char, index) => {
					switch (char) {
						case "0":
							return <Image key={index} img={zero} />;
						case "1":
							return <Image key={index} img={one} />;
						case "2":
							return <Image key={index} img={two} />;
						case "3":
							return <Image key={index} img={three} />;
						case "4":
							return <Image key={index} img={four} />;
						case "5":
							return <Image key={index} img={five} />;
						case "6":
							return <Image key={index} img={six} />;
						case "7":
							return <Image key={index} img={seven} />;
						case "8":
							return <Image key={index} img={eight} />;
						case "9":
							return <Image key={index} img={nine} />;
						case "a":
							return <Image key={index} img={a} />;
						case "b":
							return <Image key={index} img={b} />;
						case "c":
							return <Image key={index} img={c} />;
						case "d":
							return <Image key={index} img={d} />;
						case "e":
							return <Image key={index} img={e} />;
						case "f":
							return <Image key={index} img={f} />;
						case "g":
							return <Image key={index} img={g} />;
						case "h":
							return <Image key={index} img={h} />;
						case "i":
							return <Image key={index} img={i} />;
						case "j":
							return <Image key={index} img={j} />;
						case "k":
							return <Image key={index} img={k} />;
						case "l":
							return <Image key={index} img={l} />;
						case "m":
							return <Image key={index} img={m} />;
						case "n":
							return <Image key={index} img={n} />;
						case "o":
							return <Image key={index} img={o} />;
						case "p":
							return <Image key={index} img={p} />;
						case "q":
							return <Image key={index} img={q} />;
						case "r":
							return <Image key={index} img={r} />;
						case "s":
							return <Image key={index} img={s} />;
						case "t":
							return <Image key={index} img={t} />;
						case "u":
							return <Image key={index} img={u} />;
						case "v":
							return <Image key={index} img={v} />;
						case "w":
							return <Image key={index} img={w} />;
						case "x":
							return <Image key={index} img={x} />;
						case "y":
							return <Image key={index} img={y} />;
						case "z":
							return <Image key={index} img={z} />;
						case "&":
							return <Image key={index} img={and} />;
						case " ":
							return <div className="img-space"></div>;
						default:
							return "";
					}
				})}
			</div>

			<div className="keypress_form">
				<div className="keypress_form-box">
					<input
						type="text"
						maxLength={16} // Change this value
						onChange={handleKeyPress}
						placeholder="Custom text..."
						className="keypress_form-input"
					/>
				</div>
			</div>

			<div className="bg-nav">
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg1");
					}}
				>
					<img className="bg-nav__item-img" src={bg1} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg2");
					}}
				>
					<img className="bg-nav__item-img" src={bg2} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg3");
					}}
				>
					<img className="bg-nav__item-img" src={bg3} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg4");
					}}
				>
					<img className="bg-nav__item-img" src={bg4} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg5");
					}}
				>
					<img className="bg-nav__item-img" src={bg5} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg6");
					}}
				>
					<img className="bg-nav__item-img" src={bg6} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg7");
					}}
				>
					<img className="bg-nav__item-img" src={bg7} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg8");
					}}
				>
					<img className="bg-nav__item-img" src={bg8} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg9");
					}}
				>
					<img className="bg-nav__item-img" src={bg9} alt="" />
				</button>
				<button
					className="bg-nav__item"
					onClick={() => {
						setBgImage("bg10");
					}}
				>
					<img className="bg-nav__item-img" src={bg10} alt="" />
				</button>
			</div>
		</div>
	);
}

export default App;
